module.exports = __webpack_public_path__ + "img/accessibility.2be85fbd.webp";